export enum FeeType {
  SHIPPING = "SHIPPING",
  CREDIT_CARD = "CREDIT_CARD",
  ENVIRONMENTAL = "ENVIRONMENTAL",
  HANDLING = "HANDLING",
  RCS_HANDLING = "RCS_HANDLING",
  RCS_SHIPPING = "RCS_SHIPPING",
  RCS_CREDIT_CARD = "RCS_CREDIT_CARD",
  OTHER = "OTHER",
}

/**
 * RCS Handling / Shipping, plus user-created variants such as
 * "RCS_HANDLING_FEE". RCS Credit Card is a legacy computed row, not an RCS fee.
 */
export function isRcsFeeType(feeType: string | null | undefined): boolean {
  const normalized = (feeType ?? "").trim().toUpperCase();
  return (
    normalized.startsWith("RCS_") && normalized !== FeeType.RCS_CREDIT_CARD
  );
}